export default __webpack_public_path__ + "static/media/exotic.dd4ade44.svg";